import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, Popover } from 'module-tsl-ui-elements';
import { Collapsible } from 'module-tsl-ui-collapsible';
import EnhancedSelect from './EnhancedSelect';
import EnhancedInputGroup from './EnhancedInputGroup';
import EnhancedSimpleDate from './EnhancedSimpleDate';
import EnhancedFileUpload from './EnhancedFileUpload';

var SellerData = function SellerData(_ref) {
  var titles = _ref.titles,
      countries = _ref.countries,
      onHideModal = _ref.onHideModal,
      requiredFields = _ref.requiredFields,
      handleFileUpload = _ref.handleFileUpload;
  var nameContainer = classnames({
    hide: !requiredFields.name
  });
  var dobContainer = classnames({
    hide: !requiredFields.dob,
    row: true
  });
  var addressContainer = classnames({
    hide: !requiredFields.address,
    'seller-info-modal__container': true
  });
  var fileUploadContainer = classnames({
    hide: !requiredFields.identityDocument
  });
  var ssnLast4Container = classnames({
    hide: !requiredFields.ssnLast4,
    row: true
  });
  var idNumberContainer = classnames({
    hide: !requiredFields.idNumber,
    'pb-1': true
  });
  var emailContainer = classnames({
    hide: !requiredFields.email,
    row: true
  });
  var phoneContainer = classnames({
    hide: !requiredFields.phone,
    row: true
  });
  var personalContainer = classnames({
    hide: !requiredFields.name && !requiredFields.dob && !requiredFields.address
  });
  var nameDobContainer = classnames({
    hide: !requiredFields.name && !requiredFields.dob,
    'seller-info-modal__container': true
  });
  var IDContainer = classnames({
    hide: !requiredFields.ssnLast4 && !requiredFields.idNumber
  });
  var emailPhoneContainer = classnames({
    hide: !requiredFields.email && !requiredFields.phone
  });
  return /*#__PURE__*/React.createElement("section", {
    className: "padding-md"
  }, /*#__PURE__*/React.createElement("div", {
    className: personalContainer
  }, /*#__PURE__*/React.createElement("header", {
    className: "l-flex-vcenter-spaced margin-bottom-md"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--medium"
  }, "Personal Details"), /*#__PURE__*/React.createElement(Popover, {
    content: "Required data for completing payments",
    placement: "left",
    push: "left",
    tooltipBehavior: true
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon icon-tds-info-1 icon-blue icon-xxl"
  }))), /*#__PURE__*/React.createElement("div", {
    className: nameDobContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: nameContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement(EnhancedSelect, {
    name: "title",
    label: "Title",
    options: titles
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "firstname",
    label: "First Name"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "lastname",
    label: "Last Name"
  })))), /*#__PURE__*/React.createElement("div", {
    className: dobContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedSimpleDate, {
    name: "dob",
    sequence: ['day', 'month', 'year']
  })))), /*#__PURE__*/React.createElement("div", {
    className: addressContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedSelect, {
    name: "country",
    label: "Country",
    options: countries
  }), /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "address_line1",
    label: "Address"
  }), /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "address_line2"
  }), /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "city",
    label: "City or Town"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "postalcode",
    label: "Postal Code"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-6"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "state",
    label: "State"
  }))))))), /*#__PURE__*/React.createElement("div", {
    className: fileUploadContainer
  }, /*#__PURE__*/React.createElement("header", {
    className: "l-flex-vcenter-spaced margin-bottom-md"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--medium"
  }, "Identity document upload")), /*#__PURE__*/React.createElement("div", {
    className: "seller-info-modal__container"
  }, /*#__PURE__*/React.createElement(EnhancedFileUpload, {
    name: "identityDocument",
    handleFileUpload: handleFileUpload
  }), /*#__PURE__*/React.createElement(Collapsible, {
    toggler: /*#__PURE__*/React.createElement(Button, {
      theme: "tertiary",
      icon: "tds-info-1",
      size: "sm"
    }, "Help"),
    className: idNumberContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "fs-0 mt-1"
  }, /*#__PURE__*/React.createElement("p", null, "A photo (jpg or png) of the front of an identifying document, either a passport or local ID card."), /*#__PURE__*/React.createElement("p", null, "Requirements:"), /*#__PURE__*/React.createElement("ul", {
    className: "mb-1"
  }, /*#__PURE__*/React.createElement("li", null, "a color image"), /*#__PURE__*/React.createElement("li", null, "smaller than 8,000px by 8,000px"), /*#__PURE__*/React.createElement("li", null, "image is in JPG or PNG format"), /*#__PURE__*/React.createElement("li", null, "image is less than 5MB in size")), /*#__PURE__*/React.createElement("p", null, "Passport is accepted, and preferred for all countries."))))), /*#__PURE__*/React.createElement("div", {
    className: IDContainer
  }, /*#__PURE__*/React.createElement("header", {
    className: "l-flex-vcenter-spaced margin-bottom-md"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--medium"
  }, "Identity document number")), /*#__PURE__*/React.createElement("div", {
    className: "seller-info-modal__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: ssnLast4Container
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "ssnLast4",
    label: "Social Security Number (last 4 digits)"
  }))), /*#__PURE__*/React.createElement("div", {
    className: idNumberContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "idNumber",
    label: "ID Number"
  }))), /*#__PURE__*/React.createElement(Collapsible, {
    toggler: /*#__PURE__*/React.createElement(Button, {
      theme: "tertiary",
      icon: "tds-info-1",
      size: "sm"
    }, "Help"),
    className: idNumberContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "fs-0 mt-1"
  }, /*#__PURE__*/React.createElement("p", null, "What kind of ID number needed by country:"), /*#__PURE__*/React.createElement("ul", {
    className: "mb-1"
  }, /*#__PURE__*/React.createElement("li", null, "United States (US) - Social Security Number"), /*#__PURE__*/React.createElement("li", null, "Canada (CA) - Social Insurance Number"), /*#__PURE__*/React.createElement("li", null, "Hong Kong (HK)- Hong Kong Identity Card Number (HKID)"), /*#__PURE__*/React.createElement("li", null, "Singapore (SG)- National Registration Identity Card (NRIC) or Foreign Identification Number (FIN)"), /*#__PURE__*/React.createElement("li", null, "Others - Passport, government-issued ID, or driver license")), /*#__PURE__*/React.createElement("p", null, "Passport is accepted, and preferred for all countries."))))), /*#__PURE__*/React.createElement("div", {
    className: emailPhoneContainer
  }, /*#__PURE__*/React.createElement("header", {
    className: "l-flex-vcenter-spaced margin-bottom-md"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "heading heading--medium"
  }, "Email and phone")), /*#__PURE__*/React.createElement("div", {
    className: "seller-info-modal__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: emailContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "email",
    label: "Email address"
  }))), /*#__PURE__*/React.createElement("div", {
    className: phoneContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(EnhancedInputGroup, {
    name: "phone",
    label: "Phone",
    placeholder: "US Phone number: 5556781212"
  })))))), /*#__PURE__*/React.createElement("footer", {
    className: "l-flex padding-top-ml"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    type: "submit",
    className: "seller-info-modal__cta"
  }, "Next"), /*#__PURE__*/React.createElement(Button, {
    theme: "secondary",
    type: "button",
    onClick: onHideModal,
    className: "seller-info-modal__cta"
  }, "Cancel")));
};

SellerData.displayName = "SellerData";
SellerData.propTypes = {
  titles: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired,
  onHideModal: PropTypes.func.isRequired,
  handleFileUpload: PropTypes.func.isRequired,
  requiredFields: PropTypes.isRequired
};
export default SellerData;